module.exports = __webpack_public_path__ + "p4_img2.jpg?736c17fe89092dac722601f1f33d5435";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-imgs/p4/p4_img2.jpg
// module id = 55
// module chunks = 0